export class JobId {
    constructor(public readonly id: number) {}
}
